export default function isVideo(url: string) {
  return /\.(mp4)$/.test(url);
}
